import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppSettings } from '../../app.settings';
import { Client } from '../../models/client';

@Component({ standalone:false,
  selector: 'add-client-dialog',
  templateUrl: 'add-client-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['add-client-dialog.component.scss']
})
export class AddClientDialogComponent {
  title: string= "Add Client";
  message: string = "";
  confirmButtonText = "Add";
  cancelButtonText = "Cancel";

  public hide = true;

  public dialogForm: FormGroup;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private appSettings:AppSettings, private dialogRef: MatDialogRef<AddClientDialogComponent>) {
    if(data){
      this.title=data.title;
      this.message = data.message || this.message;
      if (data.buttonText) {
        this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
        this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
      }
    }
    this.dialogForm = new FormGroup({
      name: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(256)]),
    });
  }

  onConfirmClick(): void {
    if (this.dialogForm.valid) {
      let c=new Client();
      c.id=0;
      c.name=this.dialogForm.get('name')!.value;
      c.externalId=c.name;
      this.dialogRef.close(c);
    }
  }
  onCancelClick(): void {
    this.dialogRef.close(undefined);
  }

}